import React,{useState,useEffect} from 'react';

import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  WarehouseTransactionDatatable = (props) => {

    const [t] = useTranslation();     
    const [warehouseId, setWarehouseId] = useState('');      
    const [url, setUrl] = useState('');   
    const [urlExcel, setUrlExcel] = useState('');   
  
    const tableName = t('warehouse.label.transactions'); 


    
    const columns = [       
        { name: "Id", data: "id", selector: "id", omit: true},
        { name: t('general.label.name'), data: "article.name", sortable: true, selector: "article.name", minWidth: '300px'},    		
        { name: t('article.label.articleNumber'), data: "article.nbr", sortable: true, selector: "article.nbr"},    		       
        { name: t('warehouse.label.qty'), data: "qty",  sortable: true,  selector: "qty"},      
        { name: t('warehouse.label.unitExcludeVat'), data: "unitPriceExcludeVat",  sortable: true,  selector: "unitPriceExcludeVat"},      
        { name: t('warehouse.label.totalExcludeVat'), data: "totalPriceExcludeVat",  sortable: true,  selector: "totalPriceExcludeVat"},      
        { name: t('article.label.measureUnit'), data: "article.measureUnit",  sortable: true,  selector: "article.measureUnit"},      
        { name: t('warehouse.label.transactionType'), data: "transactionType", sortable: true,  selector: "transactionType"},     
        { name: t('warehouse.label.warehouseName'), data: "warehouse.name", sortable: true,  selector: "warehouse.name"},             
        { name: t('warehouse.label.transactionDate'), data: "transactionDate", sortable: true,  selector: "transactionDate"},      
        { name: t('document.label.document'), data: "document.documentNbr", sortable: true,  selector: "document.documentNbr"},
        { name: t('document.label.invoice'), data: "document.invoiceNbr", sortable: true,  selector: "document.invoiceNbr"},
        { name: t('workOrder.label.workOrder'), data: "document.workOrderNbr", sortable: true,  selector: "document.workOrderNbr"},
        { name: t('warehouse.label.ignoreForNewTransactions'), sortable: true,  selector: "ignoreForNewTransactions"},   
    ];        


    
    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name: t('general.label.name'), data: "article.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('article.label.articleNumber'), data: "article.nbr", orderable: true,  searchable: true, search: {value: '',regex: false}},       
        { name: t('warehouse.label.qty'), data: "qty", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.unitExcludeVat'), data: "unitPriceExcludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.totalExcludeVat'), data: "totalPriceExcludeVat", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('article.label.measureUnit'), data: "article.measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},  
        { name: t('warehouse.label.transactionType'), data: "transactionType", orderable: true,  searchable: true, search: {value: '',regex: false}} ,                
        { name: t('warehouse.label.warehouseName'), data: "warehouse.name", orderable: true,  searchable: true, search: {value: '',regex: false}} ,                
        { name: t('warehouse.label.transactionDate'), data: "transactionDate", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('document.label.document'), data: "document.documentNbr", orderable: true,  searchable: true, search: {value: '',regex: false}},    
        { name: t('document.label.invoice'), data: "document.invoiceNbr", orderable: true,  searchable: true, search: {value: '',regex: false}}, 
        { name: t('workOrder.label.workOrder'), data: "document.workOrderNbr", orderable: true,  searchable: true, search: {value: '',regex: false}}, 
        { name: t('workOrder.label.ignoreForNewTransactions'), data: "ignoreForNewTransactions", orderable: true,  searchable: true, search: {value: '',regex: false}} 
    ];        

  //  const url = RestService.getBaseURL()+"warehouse/getTransactionList?warehouseId="+props.warehouseId;   
   // const urlExcel = RestService.getBaseURL()+"Excel";          
    
 
    useEffect(() => {
        setWarehouseId(props.warehouseId);
        setUrl(RestService.getBaseURL()+"warehouse/getTransactionList?warehouseId="+props.warehouseId);
        setUrlExcel(RestService.getBaseURL()+"warehouse/getTransactionExcelList?warehouseId="+props.warehouseId);
      }, [props.warehouseId]);


     const handleCallback  = (id) => {
                      
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={true}
             />
           
         );
    
 
  
 };

export default WarehouseTransactionDatatable;

